import { useSelector } from 'react-redux'

import { getCurrentBusinessIsDymoConnectEnabled } from '~/store/reducers/auth'
import { getIsDymoSupported } from '~/utils/labelsUtils'

const useIsDymoConnectEnabled = () => {
  const isDymoConnectEnabled = useSelector(
    getCurrentBusinessIsDymoConnectEnabled,
  )
  const isDymoSupported = getIsDymoSupported()

  return isDymoSupported && isDymoConnectEnabled
}

export default useIsDymoConnectEnabled
